<script>
    import Image from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Image.svelte?1733898724710';
    import { get_attribute_value, get_attribute_name } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724710';
    import { get_image_path } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_image_path.js?1733898724710';

    export let name;
    export let product;
    export let width = 0;
    export let height = 0;
    export let format = null;
    export let quality = 60;
    export let sizes = null;
    export let widths = null;
    export let css = null;
    export let lazy = true;
    export let mode = 'contain';
    export let fixed = false;

    $: value = get_attribute_value(product, name);
    $: src = get_image_path(value);
    $: alt = get_attribute_name(product, 'name') || '';
</script>

{#if value && src}
    <Image {src} {width} {height} {alt} {format} {quality} {sizes} {widths} {css} {lazy} {mode} {fixed} />
{/if}
